export enum WaiverRequestCategoryEnums {
    Incapactiation = 1,
    Death = 2,
    Accident = 3,
    Weather = 4,
    Other = 5,
}